export class GenericLoaderData {
    public showLoader = false;
    public loaderMessage = '';
} 
